import { Chart } from 'chart.js'

export default {
  type: 'horizontalBar',
  data: {
    labels: [],
    datasets: [],
  },
  options: {
    animation: {
      onComplete: function() {
        const chartInstance = this.chart
        const ctx = chartInstance.ctx
        ctx.textAlign = 'center'
        ctx.font = '9px Open Sans'
        ctx.fillStyle = '#fff'

        Chart.helpers.each(
          this.data.datasets.forEach(function(dataset, i) {
            const meta = chartInstance.controller.getDatasetMeta(i)
            Chart.helpers.each(
              meta.data.forEach(function(bar, index) {
                const data = dataset.data[index] + '%'
                const barWidth = bar._model.x - bar._model.base
                const centerX = bar._model.base + barWidth / 2

                if (barWidth === 0) {
                  ctx.fillText('', centerX, bar._model.y + 4)
                } else {
                  ctx.fillText(data, centerX, bar._model.y + 4)
                }
              }),
              this
            )
          }),
          this
        )
      },
    },
    tooltips: {
      enabled: false,
    },

    events: [],

    legend: {
      display: 'true',
      position: 'bottom',
      labels: {
        boxWidth: 12,
      },
    },

    title: {
      display: false,
    },
    maintainAspectRatio: false,

    scales: {
      xAxes: [
        {
          ticks: {
            beginAtZero: true,
            suggestedMax: 100,
            callback: function(value) {
              return value + '%'
            },
          },
          scaleLabel: {
            display: false,
          },
          gridLines: {
            drawOnChartArea: true,
            color: '#c8ced3',
            zeroLineColor: '#c8ced3',
          },
          stacked: true,
        },
      ],
      yAxes: [
        {
          gridLines: {
            display: false,
            color: '#fff',
            zeroLineColor: '#fff',
            zeroLineWidth: 0,
          },
          ticks: {
            fontFamily: "'Open Sans Bold', sans-serif",
            fontSize: 11,
          },
          stacked: true,
        },
      ],
    },
  },
}
